import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import backButton from "./Images/back.png";

const Oring = () => {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();
  const [folderName, setFolderName] = useState("default");
  const [oringUrl, setOringUrl] = useState("");
  const [glbUrl, setGlbUrl] = useState("");
  const [inputs, setInputs] = useState({
    inner_diameter: "",
    cross_section_diameter: "",
  });

  // Redirect if not logged in
  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  // Inject <model-viewer>
  useEffect(() => {
    if (!document.querySelector("script#model-viewer")) {
      const script = document.createElement("script");
      script.id = "model-viewer";
      script.type = "module";
      script.src =
        "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
      document.head.appendChild(script);
    }
  }, []);

  // Fetch folder name
  useEffect(() => {
    const fetchFolderName = async () => {
      try {
        const response = await fetch("https://www.d-rosa.ai/appname");
        const data = await response.json();
        setFolderName(data.foldername || "default");
      } catch (error) {
        console.error("Error fetching folder name:", error);
      }
    };
    fetchFolderName();
  }, []);

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  // Generate STEP file
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://www.d-rosa.ai/oringdesign", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
          inner_diameter: parseFloat(inputs.inner_diameter),
          cross_section_diameter: parseFloat(inputs.cross_section_diameter),
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setOringUrl(data.oringurl || "");
        alert("O-Ring design is completed!!");
      } else {
        console.error("Error sending oring data");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  // Convert STEP ? GLB and show
  const handleView = async () => {
    try {
      const response = await fetch("https://www.d-rosa.ai/OringtoGlbb", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setGlbUrl(data.glburl || "");
      } else {
        console.error("Error converting to GLB");
      }
    } catch (error) {
      console.error("Error in handleView:", error);
    }
  };

  return (
    <div id="image-container">
      <center>
        <h2 className="center-heading">O-Ring Design</h2>
      </center>
      <p>Signed in as: {userEmail}</p>

      {/* Input form */}
      <form onSubmit={handleSubmit}>
        <input
          type="number"
          name="inner_diameter"
          value={inputs.inner_diameter}
          onChange={handleChange}
          placeholder="Inner Diameter"
          className="w-full p-2 border rounded"
          required
        />
        <br />
        <br />

        <input
          type="number"
          name="cross_section_diameter"
          value={inputs.cross_section_diameter}
          onChange={handleChange}
          placeholder="Cross Section Diameter"
          className="w-full p-2 border rounded"
          required
        />
        <br />
        <br />

        <button type="submit">Submit</button>
      </form>

      <br />
      <p>O-Ring File Path: {oringUrl}</p>

      {oringUrl && (
        <>
          <a href={oringUrl} target="_blank" rel="noopener noreferrer">
            <button style={{ padding: "10px 20px", fontSize: "16px" }}>
              Download
            </button>
          </a>
          <br />
          <br />
          <button
            onClick={handleView}
            style={{ padding: "10px 20px", fontSize: "16px" }}
          >
            View
          </button>
        </>
      )}

      {/* Show GLB in model-viewer */}
      {glbUrl && (
        <div style={{ marginTop: "20px" }}>
          <h3>3D O-Ring Model</h3>
          <model-viewer
            src={glbUrl}
            alt="O-Ring model"
            auto-rotate
            camera-controls
            ar
            shadow-intensity="1"
            style={{
              width: "600px",
              height: "400px",
              backgroundColor: "grey",
            }}
          ></model-viewer>
        </div>
      )}

      <br />
      <button onClick={() => navigate("/previous-page")}>
        <img src={backButton} alt="Back" width="60" height="60" />
      </button>

      <footer className="footer-section">
        <div className="text-6">
          &copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default Oring;
